import {
  CHECK_BAHISTA_ANALYSIS_REQUEST,
  CHECK_BAHISTA_ANALYSIS_SUCCESS,
  CHECK_BAHISTA_ANALYSIS_FAILURE,
  GET_BAHISTA_PREDICTIONS_REQUEST,
  GET_BAHISTA_PREDICTIONS_SUCCESS,
  GET_BAHISTA_PREDICTIONS_FAILURE,
  RUN_BAHISTA_ANALYZE_REQUEST,
  RUN_BAHISTA_ANALYZE_SUCCESS,
  RUN_BAHISTA_ANALYZE_FAILURE,
  CLEAR_BAHISTA_STATE,
  RESET_MATCH_CARD,
  GET_BAHISTA_AUTHOR_REQUEST,
  GET_BAHISTA_AUTHOR_SUCCESS,
  GET_BAHISTA_AUTHOR_FAILURE,
} from 'Store/constants';

const initialState = {
  eventId: null,
  hasAnalysisRequested: false,
  requestedWhileLive: false,
  predictions: [],
  meta: null,
  isLoading: false,
  error: null,
  author: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECK_BAHISTA_ANALYSIS_REQUEST:
    case GET_BAHISTA_PREDICTIONS_REQUEST:
    case RUN_BAHISTA_ANALYZE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case CHECK_BAHISTA_ANALYSIS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        eventId: action.payload?.eventId ?? state.eventId,
        hasAnalysisRequested: !!action.payload?.hasAnalysisRequested,
        requestedWhileLive: !!action.payload?.requestedWhileLive,
      };

    case GET_BAHISTA_PREDICTIONS_SUCCESS:
    case RUN_BAHISTA_ANALYZE_SUCCESS: {
      const payload = action.payload || {};
      return {
        ...state,
        isLoading: false,
        error: null,
        eventId: payload.eventId ?? state.eventId,
        hasAnalysisRequested: true,
        predictions: Array.isArray(payload.predictions) ? payload.predictions : [],
        meta: {
          authorId: payload.authorId,
          homeTeam: payload.homeTeam,
          awayTeam: payload.awayTeam,
          eventName: payload.eventName,
          leagueName: payload.leagueName,
          sportId: payload.sportId,
        },
      };
    }

    case CHECK_BAHISTA_ANALYSIS_FAILURE:
    case GET_BAHISTA_PREDICTIONS_FAILURE:
    case RUN_BAHISTA_ANALYZE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case GET_BAHISTA_AUTHOR_REQUEST:
      return state;

    case GET_BAHISTA_AUTHOR_SUCCESS:
      return {
        ...state,
        author: action.payload || null,
      };

    case GET_BAHISTA_AUTHOR_FAILURE:
      return {
        ...state,
        author: state.author,
      };

    case CLEAR_BAHISTA_STATE:
    case RESET_MATCH_CARD:
      return { ...initialState };

    default:
      return state;
  }
};
